import { render, staticRenderFns } from "./CampaignMailLogs.vue?vue&type=template&id=7c695d74&scoped=true&"
import script from "./CampaignMailLogs.vue?vue&type=script&lang=js&"
export * from "./CampaignMailLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c695d74",
  null
  
)

export default component.exports